<header class="navbar">
  <div class="">
    <ul class="nav navbar-nav navbar-right" *appLet="user$ | async as user" [hidden]="!user">
      <li class="dropdown">
        <a href="#" class="dropdown-toggle user-name" data-toggle="dropdown">
          {{ user?.name }}
          <span class="caret"></span>
        </a>
        <ul class="dropdown-menu" *appLet="selectedCompany$ | async as selectedCompany">
          <li class="e2e-company-check">
            <a (click)="showCompanySelector()"> Company : {{ selectedCompany?.name }} </a>
          </li>
          <li class="divider"></li>
          <li [hidden]="!selectedCompany" class="logout" (click)="logout()">
            <a href="#" routerLinkActive="">
              <i class="glyphicon glyphicon-log-out"></i>
              Logout
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</header>
